import NotificationsPage from "@/pages/notifications/Notifications"
import ScreenWrapper from "@/components/ScreenWrapper"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/meldingen/")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <ScreenWrapper>
      <NotificationsPage />
    </ScreenWrapper>
  )
}
